import { useTranslation } from 'react-i18next';

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-teal-50 to-white px-6">
      <div className="text-center">
        <div className="mb-8">
          <i className="ri-error-warning-line text-9xl text-teal-500"></i>
        </div>
        <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-700 mb-4">{t('notFound.title')}</h2>
        <p className="text-gray-600 mb-8">{t('notFound.description')}</p>
        <button
          onClick={() => window.REACT_APP_NAVIGATE('/')}
          className="bg-teal-500 text-white px-8 py-3 rounded-xl font-semibold hover:bg-teal-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          {t('notFound.button')}
        </button>
      </div>
    </div>
  );
}
